import { consoleLoggingIntegration, getIsolationScope, httpClientIntegration, init, isEnabled, setAttributes, } from '@sentry/browser';
import { allowsPerformanceSync, performanceCookieConsentAllowedOnce } from './consent.service';
const VIEW_TAG = 'view';
const VIEW_ASSOCIATE_VALUE = 'associate';
const DEFAULT_CONSOLE_LOGGING_LEVELS = ['error'];
function isLocalHost() {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1';
}
function isAssociateView() {
    return new URLSearchParams(window.location.search).get('view') === 'associate';
}
function isSentryDebugEnabled() {
    return new URLSearchParams(window.location.search).has('sentry_debug');
}
function parseConsoleLoggingLevels(levels) {
    if (!levels?.trim()) {
        return DEFAULT_CONSOLE_LOGGING_LEVELS;
    }
    return levels.split(',').map((level) => level.trim()).filter(Boolean);
}
function buildBaseOptions() {
    const sentryConfig = window.UNTUCKitConfig?.sentry;
    return {
        dsn: sentryConfig?.dsn,
        environment: sentryConfig?.environment,
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
        ],
        debug: isSentryDebugEnabled(),
        integrations: [
            consoleLoggingIntegration({
                levels: parseConsoleLoggingLevels(sentryConfig?.consoleLoggingLevels),
            }),
            httpClientIntegration({
                failedRequestStatusCodes: [[400, 599]],
            }),
        ],
        enableLogs: true,
    };
}
function applyAssociateViewContext() {
    if (!isAssociateView()) {
        return;
    }
    getIsolationScope().setTag(VIEW_TAG, VIEW_ASSOCIATE_VALUE);
    setAttributes({
        [VIEW_TAG]: VIEW_ASSOCIATE_VALUE,
    });
}
function initSentry() {
    if (isEnabled()) {
        return;
    }
    init(buildBaseOptions());
    applyAssociateViewContext();
}
/**
 * Initializes Sentry with console logging and HTTP client instrumentation.
 * Associate views (`?view=associate`) skip consent; all other traffic waits for
 * PieEye Performance consent (pieeye-category-performance).
 */
export function setupSentry() {
    const sentryConfig = window.UNTUCKitConfig?.sentry;
    if (!sentryConfig?.enable || isLocalHost()) {
        return;
    }
    if (isAssociateView()) {
        initSentry();
        return;
    }
    if (allowsPerformanceSync()) {
        initSentry();
        return;
    }
    performanceCookieConsentAllowedOnce.subscribe(() => {
        initSentry();
    });
}
